import { isArray, isSome, isString, isNone, either, literal, shape, } from 'isntnt';
import { resourceFieldPropertyDescriptor } from '../constants/resourceFieldPropertyDescriptor';
const isResourceIdentifierKey = either('type', 'id');
const validateFieldName = (value) => {
    if (isResourceIdentifierKey(value)) {
        throw new Error(`${value} is a reserved field name`);
    }
    return value;
};
export var ResourceFieldRoot;
(function (ResourceFieldRoot) {
    ResourceFieldRoot["ATTRIBUTES"] = "attributes";
    ResourceFieldRoot["RELATIONSHIPS"] = "relationships";
})(ResourceFieldRoot || (ResourceFieldRoot = {}));
export class ResourceField {
    constructor(name, root, flag) {
        this.name = validateFieldName(name);
        this.root = root;
        this.flag = flag;
    }
    isAttributeField() {
        return this.root === ResourceFieldRoot.ATTRIBUTES;
    }
    isOptionalAttribute() {
        return this.isAttributeField() && !Boolean(this.flag & AttributeFlag.REQUIRED);
    }
    isRequiredAttribute() {
        // Because OPTIONAL equals 0, check for the absence of the REQUIRED mask
        return this.isAttributeField() && Boolean(this.flag & AttributeFlag.REQUIRED);
    }
    isRelationshipField() {
        return this.root === ResourceFieldRoot.RELATIONSHIPS;
    }
    isToOneRelationship() {
        // Because TO_ONE equals 0, check for the absence of the TO_MANY mask
        return this.isRelationshipField() && !Boolean(this.flag & RelationshipFlag.TO_MANY);
    }
    isToManyRelationship() {
        return this.isRelationshipField() && Boolean(this.flag & RelationshipFlag.TO_MANY);
    }
}
export var AttributeFlag;
(function (AttributeFlag) {
    AttributeFlag[AttributeFlag["OPTIONAL"] = 0] = "OPTIONAL";
    AttributeFlag[AttributeFlag["REQUIRED"] = 1] = "REQUIRED";
})(AttributeFlag || (AttributeFlag = {}));
export class Attribute extends ResourceField {
    constructor(name, flag, predicate) {
        super(name, ResourceFieldRoot.ATTRIBUTES, flag);
        this.predicate = predicate;
    }
    isValid(value) {
        return this.predicate(value) || (isSome(value) && this.isOptionalAttribute());
    }
    static optional(predicate) {
        return (target, name) => {
            target.constructor.fields[name] = new Attribute(name, AttributeFlag.OPTIONAL, predicate);
            return resourceFieldPropertyDescriptor;
        };
    }
    static required(predicate) {
        return (target, name) => {
            target.constructor.fields[name] = new Attribute(name, AttributeFlag.REQUIRED, predicate);
            return resourceFieldPropertyDescriptor;
        };
    }
}
export var RelationshipFlag;
(function (RelationshipFlag) {
    RelationshipFlag[RelationshipFlag["TO_ONE"] = 0] = "TO_ONE";
    RelationshipFlag[RelationshipFlag["TO_MANY"] = 1] = "TO_MANY";
})(RelationshipFlag || (RelationshipFlag = {}));
const isResourceIdentifierOfType = (type) => shape({
    id: isString,
    type: literal(type),
});
export class Relationship extends ResourceField {
    constructor(name, flag, getResource) {
        super(name, ResourceFieldRoot.RELATIONSHIPS, flag);
        this.getResource = () => {
            // TODO: Throw if return value is not a Resource constructor
            return getResource();
        };
    }
    get type() {
        return this.getResource().type;
    }
    isValid(value) {
        const isResourceIdentifier = isResourceIdentifierOfType(this.type);
        return this.isToManyRelationship()
            ? isArray(value) && value.every(isResourceIdentifier)
            : isNone(value) || isResourceIdentifier(value);
    }
    static toOne(getResource) {
        return (target, name) => {
            ;
            target.constructor.fields[name] = new Relationship(name, RelationshipFlag.TO_ONE, getResource);
            return resourceFieldPropertyDescriptor;
        };
    }
    static toMany(getResource) {
        return (target, name) => {
            ;
            target.constructor.fields[name] = new Relationship(name, RelationshipFlag.TO_MANY, getResource);
            return resourceFieldPropertyDescriptor;
        };
    }
}
//# sourceMappingURL=ResourceField.js.map